function requiredField(input) {
  if (input.value.length < 1) {
    let hel = document.querySelector(".elertnone");
    input.nextSibling.nextElementSibling.style.display = "block";
  } else if (input.type == "email") {
    if (input.value.indexOf("@") != -1 && input.value.indexOf(".") != -1) {
      input.nextSibling.nextElementSibling.style.display = "none";
    } else {
      input.nextSibling.nextElementSibling.style.display = "block";
    }
  } else {
    input.nextSibling.nextElementSibling.style.display = "none";
  }
}
// ===========================onchange event=====================
function changevalidateerror(event) {
  let inputElement = event.target;
  let alertElement = inputElement.nextElementSibling;

  if (inputElement.value.length < 2 || inputElement.value.includes(" ")) {
    alertElement.style.display = "block";
  } else {
    alertElement.style.display = "none";
  }
}
let inputElements = document.querySelectorAll(".elertnone");
inputElements.forEach(function (inputElement) {
  inputElement.addEventListener("input", changevalidateerror);
});

// =============================onchange radio display none===========
function displayyn(e) {
  var radioButtons = e.parentElement.querySelectorAll('input[type="radio"]');
  if (e.value === "yes") {
    e.parentElement.querySelectorAll("p").forEach((ele) => {
      ele.style.display = "flex";
    });
    radioButtons[0].checked = true;
  } else {
    radioButtons[0].checked = false;
    e.parentElement.querySelectorAll("p").forEach((ele) => {
      ele.style.display = "none";
    });
  }
}
// =================random number===========================
function getRndInteger(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

// ======================reset form=================

function resetform() {
  document.querySelector(".resetform").reset();
}
// =================================submit button validatio ==========================

async function resetFormValidate() {

  var captchachange;
  let namevalidate = await NameValidator();
  let namevalidatelast = await NameValidatorlast();
  let Mobilevalidate = await MobileNumber();
  let emaiValidate = await EmailValidate();
  let Selectvalidator = await Selectvalidate();
  let Selectvalidatorr = await postelNumber();
  let captchavelid = await captchanumber();

  await captchaGenerator();
  //To Generate a new captcha everytime the submit button is clicked

  function NameValidator() {
    var name = document.getElementById("first-name").value;
    if (name == null || name == "") {
      document.getElementById("name_error").style.display = "block";
      return false;
    } else {
      document.getElementById("name_error").style.display = "none";
      return true;
    }
  }

  function NameValidatorlast() {
    var name = document.getElementById("last-name").value;
    if (name == null || name == "") {
      document.getElementById("name_error-last").style.display = "block";
      return false;
    } else {
      document.getElementById("name_error").style.display = "none";
      return true;
    }
  }

  function MobileNumber() {
    var Mobile = document.getElementById("number").value;
    var numberString = Mobile.toString();
    if (Mobile == null || Mobile == "") {
      document.getElementById("numberr").style.display = "block";
      return false;
    } else if (numberString.length < 10) {
      document.getElementById("numberr").style.display = "block";
      document.getElementById("numberr").innerHTML =
        "Number Should of be 10 digit";
      return false;
    } else {
      document.getElementById("numberr").style.display = "none";
      return true;
    }
  }

  function postelNumber() {
    var namee = document.getElementById("postell").value;
    if (namee == null || namee == "") {
      document.getElementById("postelcode").style.display = "block";
      return false;
    } else {
      document.getElementById("postelcode").style.display = "none";
      return true;
    }
  }

  function EmailValidate() {
    var Email = document.getElementById("gmaill").value;
    var emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (Email == null || Email == "") {
      document.getElementById("maill").style.display = "block";
      return false;
    } else if (!emailPattern.test(Email)) {
      document.getElementById("maill").style.display = "block";
      document.getElementById("maill").innerHTML = "Invalid Email Format";
      return false;
    } else {
      return true;
    }
  }

  function Selectvalidate() {
    select = document.getElementById("select").value;
    if (select == null || select == "") {
      document.getElementById("choss").style.display = "block";
      document.getElementById("choss").innerHTML = "Choose an option";
    } else {
      document.getElementById("choss").style.display = "none";
      return true;
    }
  }

  function captchanumber() {

    captchachange = parseInt(document.getElementById("demo").innerHTML);
    var inputvalue = parseInt(document.getElementById("valuetextin").value);
    

    if (captchachange === inputvalue) {
      return true;
    } else if (isNaN(inputvalue) || inputvalue === "") {
      document.getElementById("captchaalert").style.display = "block";
      return false;
    } else {
      document.getElementById("captchaalert").style.display = "none";
      return false;
    }
  }

  function captchaGenerator(){
    var min = 111111;
    var max = 999999;
    captchachange = Math.floor(Math.random() * (max - min + 1)) + min;
    document.getElementById("demo").innerHTML = captchachange;
  }

  if (
    emaiValidate &&
    Mobilevalidate &&
    namevalidate &&
    Selectvalidator &&
    namevalidatelast &&
    Selectvalidatorr &&
    captchavelid
  ) {
    await franchiseFormData();
    document.querySelector("#clicksecond").click();
    document.getElementById("submitform").style.display = "block";
  }
}

// ============================= state and districk=============================
var states = {
  AndhraPradesh: [
    "Anantapur",
    "Chittoor",
    "East Godavari",
    "Guntur",
    "Kadapa",
    "Krishna",
    "Kurnool",
    "Prakasam",
    "Nellore",
    "Srikakulam",
    "Visakhapatnam",
    "Vizianagaram",
    "West Godavari",
  ],
  ArunachalPradesh: [
    "Anjaw",
    "Changlang",
    "Dibang Valley",
    "East Kameng",
    "East Siang",
    "Kra Daadi",
    "Kurung Kumey",
    "Lohit",
    "Longding",
    "Lower Dibang Valley",
    "Lower Subansiri",
    "Namsai",
    "Papum Pare",
    "Siang",
    "Tawang",
    "Tirap",
    "Upper Siang",
    "Upper Subansiri",
    "West Kameng",
    "West Siang",
    "Itanagar",
  ],
  Assam: [
    "Baksa",
    "Barpeta",
    "Biswanath",
    "Bongaigaon",
    "Cachar",
    "Charaideo",
    "Chirang",
    "Darrang",
    "Dhemaji",
    "Dhubri",
    "Dibrugarh",
    "Goalpara",
    "Golaghat",
    "Hailakandi",
    "Hojai",
    "Jorhat",
    "Kamrup Metropolitan",
    "Kamrup (Rural)",
    "Karbi Anglong",
    "Karimganj",
    "Kokrajhar",
    "Lakhimpur",
    "Majuli",
    "Morigaon",
    "Nagaon",
    "Nalbari",
    "Dima Hasao",
    "Sivasagar",
    "Sonitpur",
    "South Salmara Mankachar",
    "Tinsukia",
    "Udalguri",
    "West Karbi Anglong",
  ],
  Bihar: [
    "Araria",
    "Arwal",
    "Aurangabad",
    "Banka",
    "Begusarai",
    "Bhagalpur",
    "Bhojpur",
    "Buxar",
    "Darbhanga",
    "East Champaran",
    "Gaya",
    "Gopalganj",
    "Jamui",
    "Jehanabad",
    "Kaimur",
    "Katihar",
    "Khagaria",
    "Kishanganj",
    "Lakhisarai",
    "Madhepura",
    "Madhubani",
    "Munger",
    "Muzaffarpur",
    "Nalanda",
    "Nawada",
    "Patna",
    "Purnia",
    "Rohtas",
    "Saharsa",
    "Samastipur",
    "Saran",
    "Sheikhpura",
    "Sheohar",
    "Sitamarhi",
    "Siwan",
    "Supaul",
    "Vaishali",
    "West Champaran",
  ],
  Chhattisgarh: [
    "Balod",
    "Baloda Bazar",
    "Balrampur",
    "Bastar",
    "Bemetara",
    "Bijapur",
    "Bilaspur",
    "Dantewada",
    "Dhamtari",
    "Durg",
    "Gariaband",
    "Janjgir Champa",
    "Jashpur",
    "Kabirdham",
    "Kanker",
    "Kondagaon",
    "Korba",
    "Koriya",
    "Mahasamund",
    "Mungeli",
    "Narayanpur",
    "Raigarh",
    "Raipur",
    "Rajnandgaon",
    "Sukma",
    "Surajpur",
    "Surguja",
  ],
  Goa: ["North Goa", "South Goa"],
  Gujarat: [
    "Ahmedabad",
    "Amreli",
    "Anand",
    "Aravalli",
    "Banaskantha",
    "Bharuch",
    "Bhavnagar",
    "Botad",
    "Chhota Udaipur",
    "Dahod",
    "Dang",
    "Devbhoomi Dwarka",
    "Gandhinagar",
    "Gir Somnath",
    "Jamnagar",
    "Junagadh",
    "Kheda",
    "Kutch",
    "Mahisagar",
    "Mehsana",
    "Morbi",
    "Narmada",
    "Navsari",
    "Panchmahal",
    "Patan",
    "Porbandar",
    "Rajkot",
    "Sabarkantha",
    "Surat",
    "Surendranagar",
    "Tapi",
    "Vadodara",
    "Valsad",
  ],
  Haryana: [
    "Ambala",
    "Bhiwani",
    "Charkhi Dadri",
    "Faridabad",
    "Fatehabad",
    "Gurugram",
    "Hisar",
    "Jhajjar",
    "Jind",
    "Kaithal",
    "Karnal",
    "Kurukshetra",
    "Mahendragarh",
    "Mewat",
    "Palwal",
    "Panchkula",
    "Panipat",
    "Rewari",
    "Rohtak",
    "Sirsa",
    "Sonipat",
    "Yamunanagar",
  ],
  HimachalPradesh: [
    "Bilaspur",
    "Chamba",
    "Hamirpur",
    "Kangra",
    "Kinnaur",
    "Kullu",
    "Lahaul Spiti",
    "Mandi",
    "Shimla",
    "Sirmaur",
    "Solan",
    "Una",
  ],
  JammuKashmir: [
    "Anantnag",
    "Bandipora",
    "Baramulla",
    "Budgam",
    "Doda",
    "Ganderbal",
    "Jammu",
    "Kargil",
    "Kathua",
    "Kishtwar",
    "Kulgam",
    "Kupwara",
    "Leh",
    "Poonch",
    "Pulwama",
    "Rajouri",
    "Ramban",
    "Reasi",
    "Samba",
    "Shopian",
    "Srinagar",
    "Udhampur",
  ],
  Jharkhand: [
    "Bokaro",
    "Chatra",
    "Deoghar",
    "Dhanbad",
    "Dumka",
    "East Singhbhum",
    "Garhwa",
    "Giridih",
    "Godda",
    "Gumla",
    "Hazaribagh",
    "Jamtara",
    "Khunti",
    "Koderma",
    "Latehar",
    "Lohardaga",
    "Pakur",
    "Palamu",
    "Ramgarh",
    "Ranchi",
    "Sahebganj",
    "Seraikela Kharsawan",
    "Simdega",
    "West Singhbhum",
  ],
  Karnataka: [
    "Bagalkot",
    "Bangalore Rural",
    "Bangalore Urban",
    "Belgaum",
    "Bellary",
    "Bidar",
    "Vijayapura",
    "Chamarajanagar",
    "Chikkaballapur",
    "Chikkamagaluru",
    "Chitradurga",
    "Dakshina Kannada",
    "Davanagere",
    "Dharwad",
    "Gadag",
    "Gulbarga",
    "Hassan",
    "Haveri",
    "Kodagu",
    "Kolar",
    "Koppal",
    "Mandya",
    "Mysore",
    "Raichur",
    "Ramanagara",
    "Shimoga",
    "Tumkur",
    "Udupi",
    "Uttara Kannada",
    "Yadgir",
  ],
  Kerala: [
    "Alappuzha",
    "Ernakulam",
    "Idukki",
    "Kannur",
    "Kasaragod",
    "Kollam",
    "Kottayam",
    "Kozhikode",
    "Malappuram",
    "Palakkad",
    "Pathanamthitta",
    "Thiruvananthapuram",
    "Thrissur",
    "Wayanad",
  ],
  MadhyaPradesh: [
    "Agar Malwa",
    "Alirajpur",
    "Anuppur",
    "Ashoknagar",
    "Balaghat",
    "Barwani",
    "Betul",
    "Bhind",
    "Bhopal",
    "Burhanpur",
    "Chhatarpur",
    "Chhindwara",
    "Damoh",
    "Datia",
    "Dewas",
    "Dhar",
    "Dindori",
    "Guna",
    "Gwalior",
    "Harda",
    "Hoshangabad",
    "Indore",
    "Jabalpur",
    "Jhabua",
    "Katni",
    "Khandwa",
    "Khargone",
    "Mandla",
    "Mandsaur",
    "Morena",
    "Narsinghpur",
    "Neemuch",
    "Panna",
    "Raisen",
    "Rajgarh",
    "Ratlam",
    "Rewa",
    "Sagar",
    "Satna",
    "Sehore",
    "Seoni",
    "Shahdol",
    "Shajapur",
    "Sheopur",
    "Shivpuri",
    "Sidhi",
    "Singrauli",
    "Tikamgarh",
    "Ujjain",
    "Umaria",
    "Vidisha",
  ],
  Maharashtra: [
    "Ahmednagar",
    "Akola",
    "Amravati",
    "Aurangabad",
    "Beed",
    "Bhandara",
    "Buldhana",
    "Chandrapur",
    "Dhule",
    "Gadchiroli",
    "Gondia",
    "Hingoli",
    "Jalgaon",
    "Jalna",
    "Kolhapur",
    "Latur",
    "Mumbai City",
    "Mumbai Suburban",
    "Nagpur",
    "Nanded",
    "Nandurbar",
    "Nashik",
    "Osmanabad",
    "Palghar",
    "Parbhani",
    "Pune",
    "Raigad",
    "Ratnagiri",
    "Sangli",
    "Satara",
    "Sindhudurg",
    "Solapur",
    "Thane",
    "Wardha",
    "Washim",
    "Yavatmal",
  ],
  Manipur: [
    "Bishnupur",
    "Chandel",
    "Churachandpur",
    "Imphal East",
    "Imphal West",
    "Jiribam",
    "Kakching",
    "Kamjong",
    "Kangpokpi",
    "Noney",
    "Pherzawl",
    "Senapati",
    "Tamenglong",
    "Tengnoupal",
    "Thoubal",
    "Ukhrul",
  ],
  Meghalaya: [
    "East Garo Hills",
    "East Jaintia Hills",
    "East Khasi Hills",
    "North Garo Hills",
    "Ri Bhoi",
    "South Garo Hills",
    "South West Garo Hills",
    "South West Khasi Hills",
    "West Garo Hills",
    "West Jaintia Hills",
    "West Khasi Hills",
  ],
  Mizoram: [
    "Aizawl",
    "Champhai",
    "Kolasib",
    "Lawngtlai",
    "Lunglei",
    "Mamit",
    "Saiha",
    "Serchhip",
    "Aizawl",
    "Champhai",
    "Kolasib",
    "Lawngtlai",
    "Lunglei",
    "Mamit",
    "Saiha",
    "Serchhip",
  ],
  Nagaland: [
    "Dimapur",
    "Kiphire",
    "Kohima",
    "Longleng",
    "Mokokchung",
    "Mon",
    "Peren",
    "Phek",
    "Tuensang",
    "Wokha",
    "Zunheboto",
  ],
  Odisha: [
    "Angul",
    "Balangir",
    "Balasore",
    "Bargarh",
    "Bhadrak",
    "Boudh",
    "Cuttack",
    "Debagarh",
    "Dhenkanal",
    "Gajapati",
    "Ganjam",
    "Jagatsinghpur",
    "Jajpur",
    "Jharsuguda",
    "Kalahandi",
    "Kandhamal",
    "Kendrapara",
    "Kendujhar",
    "Khordha",
    "Koraput",
    "Malkangiri",
    "Mayurbhanj",
    "Nabarangpur",
    "Nayagarh",
    "Nuapada",
    "Puri",
    "Rayagada",
    "Sambalpur",
    "Subarnapur",
    "Sundergarh",
  ],
  Punjab: [
    "Amritsar",
    "Barnala",
    "Bathinda",
    "Faridkot",
    "Fatehgarh Sahib",
    "Fazilka",
    "Firozpur",
    "Gurdaspur",
    "Hoshiarpur",
    "Jalandhar",
    "Kapurthala",
    "Ludhiana",
    "Mansa",
    "Moga",
    "Mohali",
    "Muktsar",
    "Pathankot",
    "Patiala",
    "Rupnagar",
    "Sangrur",
    "Shaheed Bhagat Singh Nagar",
    "Tarn Taran",
  ],
  Rajasthan: [
    "Ajmer",
    "Alwar",
    "Banswara",
    "Baran",
    "Barmer",
    "Bharatpur",
    "Bhilwara",
    "Bikaner",
    "Bundi",
    "Chittorgarh",
    "Churu",
    "Dausa",
    "Dholpur",
    "Dungarpur",
    "Ganganagar",
    "Hanumangarh",
    "Jaipur",
    "Jaisalmer",
    "Jalore",
    "Jhalawar",
    "Jhunjhunu",
    "Jodhpur",
    "Karauli",
    "Kota",
    "Nagaur",
    "Pali",
    "Pratapgarh",
    "Rajsamand",
    "Sawai Madhopur",
    "Sikar",
    "Sirohi",
    "Tonk",
    "Udaipur",
  ],
  Sikkim: ["East Sikkim", "North Sikkim", "South Sikkim", "West Sikkim"],
  TamilNadu: [
    "Ariyalur",
    "Chennai",
    "Coimbatore",
    "Cuddalore",
    "Dharmapuri",
    "Dindigul",
    "Erode",
    "Kanchipuram",
    "Kanyakumari",
    "Karur",
    "Krishnagiri",
    "Madurai",
    "Nagapattinam",
    "Namakkal",
    "Nilgiris",
    "Perambalur",
    "Pudukkottai",
    "Ramanathapuram",
    "Salem",
    "Sivaganga",
    "Thanjavur",
    "Theni",
    "Thoothukudi",
    "Tiruchirappalli",
    "Tirunelveli",
    "Tiruppur",
    "Tiruvallur",
    "Tiruvannamalai",
    "Tiruur",
    "Vellore",
    "Viluppuram",
    "Virudhunagar",
  ],
  Telangana: [
    "Adilabad",
    "Bhadradri Kothagudem",
    "Hyderabad",
    "Jagtial",
    "Jangaon",
    "Jayashankar",
    "Jogulamba",
    "Kamareddy",
    "Karimnagar",
    "Khammam",
    "Komaram Bheem",
    "Mahabubabad",
    "Mahbubnagar",
    "Mancherial",
    "Medak",
    "Medchal",
    "Nagarkurnool",
    "Nalgonda",
    "Nirmal",
    "Nizamabad",
    "Peddapalli",
    "Rajanna Sircilla",
    "Ranga Reddy",
    "Sangareddy",
    "Siddipet",
    "Suryapet",
    "Vikarabad",
    "Wanaparthy",
    "Warangal Rural",
    "Warangal Urban",
    "Yadadri Bhuvanagiri",
  ],
  Tripura: [
    "Dhalai",
    "Gomati",
    "Khowai",
    "North Tripura",
    "Sepahijala",
    "South Tripura",
    "Unakoti",
    "West Tripura",
  ],
  UttarPradesh: [
    "Agra",
    "Aligarh",
    "Allahabad",
    "Ambedkar Nagar",
    "Amethi",
    "Amroha",
    "Auraiya",
    "Azamgarh",
    "Baghpat",
    "Bahraich",
    "Ballia",
    "Balrampur",
    "Banda",
    "Barabanki",
    "Bareilly",
    "Basti",
    "Bhadohi",
    "Bijnor",
    "Budaun",
    "Bulandshahr",
    "Chandauli",
    "Chitrakoot",
    "Deoria",
    "Etah",
    "Etawah",
    "Faizabad",
    "Farrukhabad",
    "Fatehpur",
    "Firozabad",
    "Gautam Buddha Nagar",
    "Ghaziabad",
    "Ghazipur",
    "Gonda",
    "Gorakhpur",
    "Hamirpur",
    "Hapur",
    "Hardoi",
    "Hathras",
    "Jalaun",
    "Jaunpur",
    "Jhansi",
    "Kannauj",
    "Kanpur Dehat",
    "Kanpur Nagar",
    "Kasganj",
    "Kaushambi",
    "Kheri",
    "Kushinagar",
    "Lalitpur",
    "Lucknow",
    "Maharajganj",
    "Mahoba",
    "Mainpuri",
    "Mathura",
    "Mau",
    "Meerut",
    "Mirzapur",
    "Moradabad",
    "Muzaffarnagar",
    "Pilibhit",
    "Pratapgarh",
    "Raebareli",
    "Rampur",
    "Saharanpur",
    "Sambhal",
    "Sant Kabir Nagar",
    "Shahjahanpur",
    "Shamli",
    "Shravasti",
    "Siddharthnagar",
    "Sitapur",
    "Sonbhadra",
    "Sultanpur",
    "Unnao",
    "anasi",
  ],
  Uttarakhand: [
    "Almora",
    "Bageshwar",
    "Chamoli",
    "Champawat",
    "Dehradun",
    "Haridwar",
    "Nainital",
    "Pauri",
    "Pithoragarh",
    "Rudraprayag",
    "Tehri",
    "Udham Singh Nagar",
    "Uttarkashi",
  ],
  WestBengal: [
    "Alipurduar",
    "Bankura",
    "Birbhum",
    "Cooch Behar",
    "Dakshin Dinajpur",
    "Darjeeling",
    "Hooghly",
    "Howrah",
    "Jalpaiguri",
    "Jhargram",
    "Kalimpong",
    "Kolkata",
    "Malda",
    "Murshidabad",
    "Nadia",
    "North 24 Parganas",
    "Paschim Bardhaman",
    "Paschim Medinipur",
    "Purba Bardhaman",
    "Purba Medinipur",
    "Purulia",
    "South 24 Parganas",
    "Uttar Dinajpur",
  ],
  AndamanNicobar: ["Nicobar", "North Middle Andaman", "South Andaman"],
  Chandigarh: ["Chandigarh"],
  DadraHaveli: ["Dadra Nagar Haveli"],
  DamanDiu: ["Daman", "Diu"],
  Delhi: [
    "Central Delhi",
    "East Delhi",
    "New Delhi",
    "North Delhi",
    "North East Delhi",
    "North West Delhi",
    "Shahdara",
    "South Delhi",
    "South East Delhi",
    "South West Delhi",
    "West Delhi",
  ],
  Lakshadweep: ["Lakshadweep"],
  Puducherry: ["Karaikal", "Mahe", "Puducherry", "Yanam"],
};
// states.Maharashtra = ["Mumbai","Pune","Nagpur","Thane","Nashik","Navi Mumbai","Aurangabad","Solapur","Amravati","Nanded","Kolhapur","Sangli","Jalgaon","Akola","Latur","Dhule","Ahmednagar","Miraj","Chandrapur","Parbhani","Jalna","Bhusawal","Navi Mumbai Panvel Raigad","Satara","Beed","Yavatmal","Kamptee","Gondia","Barshi","Achalpur","Osmanabad","Nandurbar","Wardha","Udgir","Hinganghat"];
states.Bihar[0] = "Araria District";
var handleSelectChange = async (e) => {
  const districtSelect = document.querySelector(".districtSelect");

  // Check if a state is selected
  if (e.target.value) {
    districtSelect.innerHTML = ""; // Clear the district options

    states[e.target.value].forEach((district) => {
      districtSelect.innerHTML += `<option value="${district}">${district}</option>`;
    });

    districtSelect.style.display = "block"; // Show the district select
  } else {
    districtSelect.innerHTML = ""; // Clear the district options
    districtSelect.style.display = "none"; // Hide the district select
  }
};

// ==================================radio button check=========
function radiobuttonicon(element) {
  const checkButtonIcons = document.querySelectorAll(".checkbuttoniconown");
  checkButtonIcons.forEach((iconBlock) => {
    iconBlock.style.display = "none";
    element.parentElement.querySelector('input[type="radio"]').checked = false;
  });
  const clickedIcon = element.querySelector(".checkbuttoniconown");
  clickedIcon.style.display = "block";
  element.parentElement.querySelector('input[type="radio"]').checked = true;
}
function radiobuttoniconn(element) {
  const checkButtonIcons = document.querySelectorAll(".checkbuttonicono");
  checkButtonIcons.forEach((iconBlock) => {
    iconBlock.style.display = "none";
    element.parentElement.querySelector('input[type="radio"]').checked = false;
  });
  const clickedIcon = element.querySelector(".checkbuttonicono");
  clickedIcon.style.display = "block";
  element.parentElement.querySelector('input[type="radio"]').checked = true;
}
function radiobuttoniconamount(element) {
  const checkButtonIcons = document.querySelectorAll(".checkbuttoniconoamount");
  checkButtonIcons.forEach((iconBlock) => {
    iconBlock.style.display = "none";
    element.parentElement.querySelector('input[type="radio"]').checked = false;
  });
  const clickedIcon = element.querySelector(".checkbuttoniconoamount");
  clickedIcon.style.display = "block";
  element.parentElement.querySelector('input[type="radio"]').checked = true;
}
function radiobuttoniconstore(element) {
  const checkButtonIcons = document.querySelectorAll(".checkbuttoniconstore");
  checkButtonIcons.forEach((iconBlock) => {
    iconBlock.style.display = "none";
    element.parentElement.querySelector('input[type="radio"]').checked = false;
  });
  const clickedIcon = element.querySelector(".checkbuttoniconstore");
  clickedIcon.style.display = "block";
  element.parentElement.querySelector('input[type="radio"]').checked = true;
}
function validateNumericInput() {
  const inputField = document.getElementById("number");
  const inputValue = inputField.value;
  const numericValue = inputValue.replace(/[^0-9]/g, "");
  inputField.value = numericValue;
}
function validateNumericInputpost() {
  let inputField = document.getElementById("postell");
  let inputValue = inputField.value;
  inputValue = inputValue.replace(/^0+/, "");
  let numericValue = inputValue.replace(/[^0-9]/g, "");
  inputField.value = numericValue;
}

function validateNumericInputname() {
  let inputname = document.querySelector("#first-name");
  let inputValuename = inputname.value;
  let alphabeticValue = inputValuename.replace(/[^a-zA-Z]/g, "");
  inputname.value = alphabeticValue;
}
function validateNumericInpulasttname() {
  let inputname = document.querySelector("#last-name");
  let inputValuename = inputname.value;
  let alphabeticValue = inputValuename.replace(/[^a-zA-Z]/g, "");
  inputname.value = alphabeticValue;
}
function validateNumericcaptcha() {
  let inputField = document.getElementById("valuetextin");
  let inputValue = inputField.value;
  let numericValue = inputValue.replace(/[^0-9]/g, "");
  inputField.value = numericValue;
}
function validateEmail() {
  let inputField = document.getElementById("gmaill");
  let inputValue = inputField.value;
  let numericValue = inputValue.replace(/^[^\s@]+@[^\s@]+\.[^a-zA-Z]/g);
  inputField.value = numericValue;
}

function franchiseFormData() {
  let firstName = document.querySelector("#first-name").value || "empty"; 
  let lastName = document.querySelector("#last-name").value || "empty";
  let address = document.querySelector("#message").value || "empty";
  let state = document.querySelector("#select").value || "empty";
  let district = document.querySelector(".districtSelect").value || "empty";
  let postalCode = document.querySelector("#postell").value || "empty";
  let email = document.querySelector("#gmaill").value || "empty";
  let phoneNumber = document.querySelector("#number").value || "empty";
  let fax = document.querySelector('[name="contact[fax]"]').value || "empty";
  let storeLocation = document.querySelector("#storeLocation").value || "empty";

  let storeLocationType = "empty";
  let carpetArea = "empty";
  let amountToInvest = "empty";
  let hearJockeyExclusiveStore = "empty";

  document.querySelectorAll(".handleRadioClick.opcityradio").forEach((e) => {
    if (e.checked == true) {
      storeLocationType = e.parentElement.innerText;
    }
  });

  document.querySelectorAll(".handleRadioClickqs.opcityradio").forEach((e) => {
    if (e.checked == true) {
      carpetArea = e.parentElement.innerText;
    }
  });

  document
    .querySelectorAll(".handleRadioClickamount.opcityradio")
    .forEach((e) => {
      if (e.checked == true) {
        amountToInvest = e.parentElement.innerText;
      }
    });

  document
    .querySelectorAll(".handleRadioClickstore.opcityradio")
    .forEach((e) => {
      if (e.checked == true) {
        hearJockeyExclusiveStore = e.parentElement.innerText;
      }
    });

  const franchiseHeaders = new Headers();
  franchiseHeaders.append("Content-Type", "application/json");


  const franchiseData = JSON.stringify({
    message: `Hi jockey team,<br> Below are details for the franchise <br><br> <b>First Name</b> : ${firstName} <br> <b>Last Name</b> : ${lastName}<br> <b>Address</b> : ${address}<br> <b>State</b> : ${state}<br> <b>District</b> : ${district}<br> <b>Postal Code</b> : ${postalCode}<br> <b>Email</b> : ${email}<br> <b>Phone</b> : ${phoneNumber}<br> <b>Fax</b> : ${fax}<br> <b>Store Location</b> : ${storeLocation}<br> <b>Store Location Type</b> : ${storeLocationType}<br> <b>Carpet Area</b> : ${carpetArea}<br> <b>Amount To Invest</b> : ${amountToInvest}<br> <b>Where did you hear about Jockey</b> : ${hearJockeyExclusiveStore}<br><br> Thank you`
  });
  
  const FranchiseRequestOptions = {
    method: "POST",
    headers: franchiseHeaders,
    body: franchiseData,
    redirect: "follow"
  };


  fetch(`${fetchCustomerOrderUpdate}/api/multiLineMessageNotification`,FranchiseRequestOptions)
    .then((response) =>    response.json() )
    .then((data) => {
        console.log(response);
        if(data.ok == true){
         window.location.reload();
        } 
      })
    .catch((error) => {
        console.log(error);
        window.location.reload();
    });
}